(function () {
  'use strict';

  /*********************************
   * GLOBAL GUARDS
   *********************************/
  let cartInitTimeout = null;
  let isCartInitializing = false;

  function safeInitializeCartOffers(itemCount = null) {
    if (isCartInitializing) return;

    clearTimeout(cartInitTimeout);

    cartInitTimeout = setTimeout(() => {
      isCartInitializing = true;

      initializeCartOffersAfterUpdate(itemCount).finally(() => {
        setTimeout(() => {
          isCartInitializing = false;
        }, 300);
      });
    }, 300);
  }

  /*********************************
   * BASE INIT (ON PAGE LOAD)
   *********************************/
  function initCartOffers() {
    setupPopupHandlersOnce();
    setupCouponSyncOnce();
    setupApplyHandlersOnce();
    setupRemoveCouponHandlerOnce();
    setupQuantitySelectorsOnce();
    checkOfferEligibility();
  }

  /*********************************
   * POPUP HANDLERS (ONCE)
   *********************************/
  function setupPopupHandlersOnce() {
    const viewBtn = document.getElementById('cart-view-all-offers');
    const popup = document.getElementById('cart-offers-popup');
    const closeBtn = popup?.querySelector('.cart-offers-popup__close');
    const overlay = popup?.querySelector('.cart-offers-popup__overlay');

    if (viewBtn && !viewBtn.dataset.bound) {
      viewBtn.dataset.bound = 'true';
      viewBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openOffersPopup();
      });
    }

    if (closeBtn && !closeBtn.dataset.bound) {
      closeBtn.dataset.bound = 'true';
      closeBtn.addEventListener('click', closeOffersPopup);
    }

    if (overlay && !overlay.dataset.bound) {
      overlay.dataset.bound = 'true';
      overlay.addEventListener('click', closeOffersPopup);
    }

    if (!document.body.dataset.escapeBound) {
      document.body.dataset.escapeBound = 'true';
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup?.getAttribute('aria-hidden') === 'false') {
          closeOffersPopup();
        }
      });
    }
  }

  function openOffersPopup() {
    const popup = document.getElementById('cart-offers-popup');
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    checkOfferEligibility();
  }

  function closeOffersPopup() {
    const popup = document.getElementById('cart-offers-popup');
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /*********************************
   * COUPON INPUT SYNC (ONCE)
   *********************************/
  function setupCouponSyncOnce() {
    const input = document.getElementById('cart-coupon-input');
    const popupInput = document.getElementById('cart-offers-coupon-input');
    const btn = document.getElementById('cart-coupon-apply-btn');
    const popupBtn = document.getElementById('cart-offers-popup-apply-btn');

    if (!input || !popupInput || input.dataset.synced) return;
    input.dataset.synced = 'true';

    input.addEventListener('input', () => {
      popupInput.value = input.value;
      toggleApplyButton(input, btn);
      toggleApplyButton(popupInput, popupBtn);
    });

    popupInput.addEventListener('input', () => {
      input.value = popupInput.value;
      toggleApplyButton(input, btn);
      toggleApplyButton(popupInput, popupBtn);
    });
  }

  /*********************************
   * APPLY HANDLERS (ONCE)
   *********************************/
  function setupApplyHandlersOnce() {
    bindApplyOnce('cart-coupon-input', 'cart-coupon-apply-btn');
    bindApplyOnce('cart-offers-coupon-input', 'cart-offers-popup-apply-btn');
  }

  function bindApplyOnce(inputId, btnId) {
    const input = document.getElementById(inputId);
    const btn = document.getElementById(btnId);

    if (!input || !btn || input.dataset.bound) return;
    input.dataset.bound = 'true';
    btn.dataset.bound = 'true';

    toggleApplyButton(input, btn);

    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && input.value.trim()) {
        e.preventDefault();
        applyCouponCode(input.value.trim(), input, btn);
      }
    });

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (input.value.trim()) {
        applyCouponCode(input.value.trim(), input, btn);
      } 
    });
  } 

  function toggleApplyButton(input, btn) {
    if (!input || !btn) return;
    btn.style.display = input.value.trim() ? 'block' : 'none';
  }

    // async function showAppliedCouponUI(code) {
    //     const wrapper = document.getElementById('cart-applied-coupon');
    //     const codeEl = document.getElementById('applied-coupon-code');
    //     const savedEl = document.getElementById('applied-coupon-saved');

    //     const popupInput  = document.querySelector('.cart-offers-popup__coupon-input-wrapper');

    //     if (!wrapper || !codeEl || !savedEl) return;

    //     codeEl.textContent = `${code} applied`;

    //     try {
    //         const res = await fetch('/cart.js');
    //         const cart = await res.json();

    //         const original = Number(cart.original_total_price || 0);
    //         const total = Number(cart.total_price || 0);
    //         const savings = original - total;

    //         if (savings <= 0) {
    //         savedEl.style.display = 'none';
    //         wrapper.style.display = 'flex';
    //         return;
    //         }

    //         let formattedSavings;

    //         // ✅ USE SHOPIFY FORMAT (BEST)
    //         if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    //         formattedSavings = Shopify.formatMoney(savings);
    //         } else {
    //         // Fallback (removes US$ → $)
    //         formattedSavings = `$${(savings / 100).toFixed(2)}`;
    //         }

    //         savedEl.textContent = `Saved ${formattedSavings}`;
    //         savedEl.style.display = 'block';
    //         wrapper.style.display = 'flex';

    //     } catch (err) {
    //         console.error('Coupon savings calculation failed:', err);
    //         savedEl.style.display = 'none';
    //         wrapper.style.display = 'flex';
    //     }
    // }
    async function showAppliedCouponUI(code) {
        const appliedBlocks = document.querySelectorAll('.cart-applied-coupon');

        if (!appliedBlocks.length) return;

        let savingsText = '';

        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();

            const savings = (cart.original_total_price || 0) - (cart.total_price || 0);

            if (savings > 0) {
            savingsText = (window.Shopify && Shopify.formatMoney)
                ? Shopify.formatMoney(savings)
                : `$${(savings / 100).toFixed(2)}`;
            }
        } catch (e) {
            console.error(e);
        }

        appliedBlocks.forEach(block => {
            const codeEl = block.querySelector('.cart-applied-coupon__code');
            const savedEl = block.querySelector('.cart-applied-coupon__saved');

            if (!codeEl || !savedEl) return;

            codeEl.textContent = `${code} applied`;

            if (savingsText) {
            savedEl.textContent = `Saved ${savingsText}`;
            savedEl.style.display = 'inline-block';
            } else {
            savedEl.style.display = 'none';
            }

            block.style.display = 'flex';
        });

        /* 🔒 Hide both inputs */
        document.querySelectorAll(
            '.cart-coupon-input-wrapper, .cart-offers-popup__coupon-input-wrapper'
        ).forEach(el => {
            el.style.display = 'none';
        });
    }




  // function setupRemoveCouponHandlerOnce() {
  //   const removeBtn = document.getElementById('remove-applied-coupon');

  //   if (!removeBtn || removeBtn.dataset.bound) return;
  //   removeBtn.dataset.bound = 'true';

  //   removeBtn.addEventListener('click', function () {
  //     // Clear Shopify discount
  //     fetch('/discount/CLEAR', {
  //       method: 'GET',
  //       headers: {
  //         "X-Requested-With": "XMLHttpRequest"
  //       }
  //     }).then(() => {
  //       hideAppliedCouponUI();

  //       // Reset input
  //       const input = document.getElementById('cart-coupon-input');
  //       if (input) {
  //         input.value = '';
  //         input.disabled = false;
  //       }

  //       // Notify cart to refresh
  //       document.dispatchEvent(new CustomEvent('cart:update'));

  //       // Refresh drawer if function exists
  //       if (typeof updateCartDrawer === 'function') {
  //         updateCartDrawer();
  //       }
  //     });
  //   });
  // }
  // function removeAppliedDiscount() {
  //   fetch('/discount/CLEAR', {
  //     method: 'GET',
  //     headers: {
  //       'X-Requested-With': 'XMLHttpRequest'
  //     }
  //   })
  //   .then(() => {
  //     // Remove local storage state
  //     localStorage.removeItem('applied_coupon_code');
  
  //     // Hide applied coupon UI
  //     hideAppliedCouponUI();
  
  //     // Reset input
  //     const input = document.getElementById('cart-coupon-input');
  //     if (input) {
  //       input.value = '';
  //       input.disabled = false;
  //     }
  
  //     // Trigger cart refresh
  //     document.dispatchEvent(new CustomEvent('cart:update'));
  
  //     // Refresh drawer if available
  //     if (typeof updateCartDrawer === 'function') {
  //       updateCartDrawer();
  //     }
  //   })
  //   .catch(err => {
  //     console.error('Error removing discount:', err);
  //   });
  // }

  function removeAppliedDiscount() {
    if (window.BotanicEarthCoupon && typeof window.BotanicEarthCoupon.remove === 'function') {
      window.BotanicEarthCoupon.remove();
      return;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: ''
      })
    })
    .then(() => {
      localStorage.removeItem('applied_coupon_code');
      sessionStorage.removeItem('botanic_applied_coupon');
      hideAppliedCouponUI();
      const discountInput = document.querySelector('[data-cart-discount]');
      if (discountInput) discountInput.value = '';

      if (typeof updateCartDrawer === 'function') {
        updateCartDrawer();
      }
    })
    .catch(err => console.error(err));
  }
  
  

  function setupRemoveCouponHandlerOnce() {
    const btn = document.getElementById('remove-applied-coupon');
    if (!btn || btn.dataset.bound) return;
  
    btn.dataset.bound = 'true';
    btn.addEventListener('click', removeAppliedDiscount);
  }
  
  function forceCartUpdate(source = 'discount') {
    // Debounced + safe
    clearTimeout(window.__forceCartTimer);

    window.__forceCartTimer = setTimeout(() => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              ...cart,
              source
            }
          }));
        })
        .catch(console.error);
    }, 150);
  }

  
  function hideAppliedCouponUI() {
    const wrapper = document.getElementById('cart-applied-coupon');
    const inputWrapper = document.querySelector('.cart-coupon-input-wrapper');
    const popupInput  = document.querySelector('.cart-offers-popup__coupon-input-wrapper');
  
    if (wrapper) wrapper.style.display = 'none';
    if (inputWrapper) inputWrapper.style.display = 'flex';
    if (popupInput) popupInput.style.display = 'flex';
  }

  function applyCouponCode(code, inputElement, applyButton) {
    if (!code || !code.trim()) { 
      return;
    } 

    if (window.BotanicEarthCoupon && typeof window.BotanicEarthCoupon.apply === 'function') {
      window.BotanicEarthCoupon.apply(code.trim(), applyButton);
      return;
    }

    const discountCode = code.trim();
    const wrapper = inputElement.closest('.cart-coupon-input-wrapper') || 
                    inputElement.closest('.cart-offers-popup__coupon-input-wrapper');
    
    if (!wrapper) return;

    const loader = wrapper.querySelector('.cart-coupon-loader') || 
                   wrapper.querySelector('.cart-offers-popup__coupon-loader');
    const successMsg = wrapper.querySelector('.cart-coupon-success') || 
                      wrapper.querySelector('.cart-offers-popup__coupon-success');

    if (applyButton) applyButton.style.display = 'none';
    if (loader) loader.style.display = 'flex';
    if (successMsg) successMsg.style.display = 'none';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: discountCode })
    })
    .then((response) => {
      if (!response.ok) throw new Error('Discount apply failed');
      return response.json();
    })
    .then((cart) => {
      if (loader) loader.style.display = 'none';

      const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const match = codes.find((d) => (d.code || '').toUpperCase() === discountCode.toUpperCase());
      const applied = match ? match.applicable !== false : (Number(cart.total_discount) || 0) > 0;

      if (!applied) {
        if (applyButton && inputElement.value.trim()) applyButton.style.display = 'block';
        alert('This coupon is not valid for the current cart.');
        return;
      }

      localStorage.setItem('applied_coupon_code', discountCode);
      sessionStorage.setItem('botanic_applied_coupon', discountCode);
      showAppliedCouponUI(discountCode);
      if (successMsg) successMsg.style.display = 'flex';

      const discountInput = document.querySelector('[data-cart-discount]');
      if (discountInput) discountInput.value = discountCode;

      if (typeof updateCartDrawer === 'function') {
        updateCartDrawer(cart);
      }
    })
    .catch((err) => {
      console.error('Discount apply failed:', err);
      if (loader) loader.style.display = 'none';
      if (applyButton && inputElement.value.trim()) {
        applyButton.style.display = 'block';
      }
      alert('Something went wrong. Please try again.');
    });
  }

  /*********************************
   * CART + OFFERS LOGIC
   *********************************/
  function checkOfferEligibility() {
    const wrapper = document.querySelector('[data-cart-wrapper]');
    const count = parseInt(wrapper?.dataset.ccount || 0);

    document.querySelectorAll('.cart-offers-popup__offer-item').forEach((item) => {
      const min = parseInt(item.dataset.minQty || 0);
      const label = item.querySelector('.cart-offers-popup__offer-unavailable');

      if (count >= min) {
        item.classList.add('offer-available');
        item.classList.remove('offer-unavailable');
        if (label) label.textContent = 'Available';
      } else {
        item.classList.add('offer-unavailable');
        item.classList.remove('offer-available');
        if (label) label.textContent = 'Add eligible items to unlock this offer';
      }
    });
  }

  function toggleCartOffersSections(count) {
    document.querySelectorAll('[data-cart-offers-section]').forEach((s) => {
      s.style.display = count > 0 ? '' : 'none';
    });
  }

  async function fetchCartData() {
    try {
      const r = await fetch('/cart.js');
      const c = await r.json();
      return c.item_count || 0;
    } catch {
      return 0;
    }
  }

  /*********************************
   * QUANTITY SELECTOR RE-INITIALIZATION
   *********************************/
  function setupQuantitySelectorsOnce() {
    // Use event delegation on document.body (works even after DOM replacement)
    if (document.body.dataset.qtyHandlersBound) return;
    document.body.dataset.qtyHandlersBound = 'true';

    // Track processing to prevent double updates
    let isProcessing = false;

    // Handle quantity increase/decrease buttons using event delegation
    document.body.addEventListener('click', function(e) {
      const increaseBtn = e.target.closest('[data-quantity-selector][data-increase-qty]');
      const decreaseBtn = e.target.closest('[data-quantity-selector][data-decrease-qty]');
      
      // Only handle if inside cart drawer
      const cartDrawer = (increaseBtn || decreaseBtn)?.closest('#t4s-mini_cart');
      if (!cartDrawer) return;
      
      if (increaseBtn || decreaseBtn) {
        // Prevent other handlers from running
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Prevent double processing
        if (isProcessing) return;
        
        const wrapper = (increaseBtn || decreaseBtn).closest('[data-quantity-wrapper]');
        if (!wrapper) return;
        
        const input = wrapper.querySelector('[data-quantity-value]');
        if (!input) return;
        
        // Check if button was already processed (prevent double clicks)
        const button = increaseBtn || decreaseBtn;
        if (button.dataset.processing === 'true') return;
        button.dataset.processing = 'true';
        
        // Get current quantity from input value (not from attribute)
        const currentQty = parseInt(input.value) || parseInt(input.getAttribute('data-current-qty')) || 1;
        // const minQty = parseInt(input.getAttribute('min')) || 1;
        const minQty = isNaN(parseInt(input.getAttribute('min'))) ? 1 : parseInt(input.getAttribute('min'));
        const maxQty = parseInt(input.getAttribute('max')) || 9999;
        let newQty = currentQty;
        
        if (increaseBtn) {
          newQty = Math.min(currentQty + 1, maxQty);
        } else if (decreaseBtn) {
          newQty = currentQty <= minQty ? 0 : currentQty - 1;
        }
        
        // Only update if quantity actually changed
        if (newQty !== currentQty) {
          isProcessing = true;
          
          // Update input value immediately
          input.value = newQty;
          input.setAttribute('data-current-qty', newQty);
          
          // Update cart via AJAX
          const itemKey = input.getAttribute('data-id') || input.getAttribute('id')?.replace('miniupdates_', '');
          if (!itemKey) {
            button.dataset.processing = 'false';
            isProcessing = false;
            return;
          }
          
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: newQty
            })
          })
          .then(response => response.json())
          .then(cart => {
            // Update data-current-qty attribute
            input.setAttribute('data-current-qty', newQty);
            
            // Dispatch cart update events (mark as from quantity change to avoid double loader)
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { ...cart, fromQuantityChange: true } }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { ...cart, fromQuantityChange: true } }));
            
            safeInitializeCartOffers(cart.item_count);
            
            // Reset processing flag
            setTimeout(() => {
              button.dataset.processing = 'false';
              isProcessing = false;
            }, 300);
          })
          .catch(error => {
            console.error('Error updating cart quantity:', error);
            // Revert input value on error
            const originalQty = parseInt(input.getAttribute('data-current-qty')) || currentQty;
            input.value = originalQty;
            
            // Reset processing flag
            button.dataset.processing = 'false';
            isProcessing = false;
          });
        } else {
          button.dataset.processing = 'false';
        }
      }
    }, true); // Use capture phase to run before other handlers

    // Handle quantity input changes (for manual input)
    document.body.addEventListener('change', function(e) {
      const input = e.target.closest('[data-quantity-value][data-action-change]');
      if (!input) return;
      
      // Only handle if inside cart drawer
      const cartDrawer = input.closest('#t4s-mini_cart');
      if (!cartDrawer) return;
      
      // Prevent double processing
      if (isProcessing) return;
      if (input.dataset.processing === 'true') return;
      input.dataset.processing = 'true';
      
      const itemKey = input.getAttribute('data-id') || input.getAttribute('id')?.replace('miniupdates_', '');
      if (!itemKey) {
        input.dataset.processing = 'false';
        return;
      }
      
      const newQty = parseInt(input.value) || 0;
      // const minQty = parseInt(input.getAttribute('min')) || 1;
      const minQty = isNaN(parseInt(input.getAttribute('min'))) ? 1 : parseInt(input.getAttribute('min'));
      const maxQty = parseInt(input.getAttribute('max')) || 9999;
      
      // Validate quantity
      if (newQty < minQty) {
        input.value = minQty;
        input.dataset.processing = 'false';
        return;
      }
      if (newQty > maxQty) {
        input.value = maxQty;
        input.dataset.processing = 'false';
        return;
      }
      
      // Check if quantity actually changed
      const currentQty = parseInt(input.getAttribute('data-current-qty')) || parseInt(input.value) || 1;
      if (newQty === currentQty) {
        input.dataset.processing = 'false';
        return;
      }
      
      isProcessing = true;
      
      // Update cart via AJAX
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newQty
        })
      })
      .then(response => response.json())
      .then(cart => {
        // Update data-current-qty attribute
        input.setAttribute('data-current-qty', newQty);
        
        // Dispatch cart update events (mark as from quantity change to avoid double loader)
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { ...cart, fromQuantityChange: true } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { ...cart, fromQuantityChange: true } }));
        
        safeInitializeCartOffers(cart.item_count);
        
        // Reset processing flag
        setTimeout(() => {
          input.dataset.processing = 'false';
          isProcessing = false;
        }, 300);
      })
      .catch(error => {
        console.error('Error updating cart quantity:', error);
        // Revert input value on error
        const originalQty = parseInt(input.getAttribute('data-current-qty')) || 1;
        input.value = originalQty;
        
        // Reset processing flag
        input.dataset.processing = 'false';
        isProcessing = false;
      });
    });
  }

  /*********************************
   * SAFE RE-INIT AFTER DRAWER UPDATE
   *********************************/
  function initializeCartOffersAfterUpdate(itemCount) {
    return new Promise(async (resolve) => {
      const count = itemCount ?? (await fetchCartData());
      toggleCartOffersSections(count);
      setupPopupHandlersOnce();
      setupCouponSyncOnce();
      setupApplyHandlersOnce();
      setupRemoveCouponHandlerOnce();
      checkOfferEligibility();

      const savedCoupon = localStorage.getItem('applied_coupon_code');
      if (savedCoupon) {
        showAppliedCouponUI(savedCoupon);
      }
      
      // Ensure quantity selectors are set up (idempotent, safe to call multiple times)
      setupQuantitySelectorsOnce();
      
      resolve();
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-remove-coupon]');
    if (!btn) return;
  
    e.preventDefault();
    removeAppliedDiscount();
  });

  /*********************************
   * EVENTS
   *********************************/
    // Listen for cart update events and show loader

  const cartUpdateEventNames = ['cart:update', 'cart:updated', 'cart-drawer:html-updated', 'change:ajaxCart', 'add:cart:success', 'cart:refresh'];

  cartUpdateEventNames.forEach((eventName) => {
    document.addEventListener(eventName, (ev) => {
      // Show loader when cart update starts (unless it's from quantity change which handles its own loader)
      const isFromQuantityChange = ev.detail?.fromQuantityChange === true;
      if (!isFromQuantityChange && typeof window.showCartLoader === 'function') {
        // Small delay to avoid showing loader for instant updates
        setTimeout(() => {
          const cartDrawer = document.querySelector('#t4s-mini_cart');
          if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
          }
        }, 50);
      }
    });
  });

  /*********************************
   * MUTATION OBSERVER (FIXED)
   *********************************/
  const cartDrawer = document.querySelector('#t4s-mini_cart');

  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      let shouldInit = false;
      let drawerContentUpdated = false;

      mutations.forEach((m) => {
        if (
          m.type === 'attributes' &&
          m.attributeName === 'aria-hidden' &&
          cartDrawer.getAttribute('aria-hidden') === 'false'
        ) {
          shouldInit = true;
        }

        if (m.type === 'childList' && m.addedNodes.length) {
          if (cartDrawer.querySelector('[data-cart-offers-section]')) {
            shouldInit = true;
          }
          // Detect when cart drawer content is updated
          drawerContentUpdated = true;
        }
      });

      if (shouldInit) {
        safeInitializeCartOffers();
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    });
  }

  /*********************************
   * INITIAL LOAD
   *********************************/
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartOffers);
  } else {
    initCartOffers();
  }
})();